import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'
import promociones, { promocion } from './promociones/store'

export const comercial = new schema.Entity('comercial', {}, { idAttribute: 'ID_ACTOR' })

export default {
  namespaced: true,
  modules: {
    promociones
  },
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
      Object.keys(state.list).forEach(key => {
        let auxPromos = state.list[key].promociones.map(p => {
          return {
            codigo: p.CODIGO_PROMOCION,
            descripcion: p.DESC_PROMOCION,
            cod_sociedad: p.CODIGO_SOCIEDAD != null ? p.CODIGO_SOCIEDAD : '' 
          }
        })
        state.list[key].promociones = auxPromos.map(x => { return {...x} })
      })
    },
    updateSet (state, payload) {
      state.list = Object.assign({}, state.list, payload.comercial)
    }
  },
  actions: {
    loadAll ({ commit, dispatch }) { // Devuelve todas las facturas
      return new Promise((resolve, reject) => {
        api.get('/comerciales/get_lista')
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [comercial])
              commit('setAll', normalizedData.entities.comercial)
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loadPromociones ({ commit, dispatch }, id) { // Devuelve todas las promociones
      return new Promise((resolve, reject) => {
        api.get('/comerciales/get_lista_promociones', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [promocion])
              commit('comerciales/promociones/setAll', normalizedData.entities.promocion, { root: true })
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loadPromocionesGestor ({ dispatch }, id) { // Devuelve todas las promociones
      return new Promise((resolve, reject) => {
        api.get('/comerciales/get_lista_gestor_promociones', {
          params: {
            jsondata: JSON.stringify({
              parametros: {
                id
              }
            })
          }
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve(response.data.result.data.data)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    crear ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/crear', {
          jsondata: JSON.stringify({
            parametros: {
              email: obj.email,
              nombre: obj.nombre,
              apellidos: obj.apellidos,
              tipoDocumento: obj.tipoDocumento,
              numeroDocumento: obj.numeroDocumento,
              rol: obj.rol
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarDatos ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/modificar_datos', {
          jsondata: JSON.stringify({
            parametros: {
              email: obj.email,
              nombre: obj.nombre,
              apellidos: obj.apellidos,
              tipoDocumento: obj.tipoDocumento,
              numeroDocumento: obj.numeroDocumento,
              telefono: obj.telefono,
              rol: obj.rol
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarPromociones ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/modificar_promociones', {
          jsondata: JSON.stringify({
            parametros: {
              id: obj.id,
              promociones: obj.promociones,
              promocionesGestor: obj.promocionesGestor
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    bloquear ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/bloquear', {
          jsondata: JSON.stringify({
            parametros: {
              id: Number(id)
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    desbloquear ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/desbloquear', {
          jsondata: JSON.stringify({
            parametros: {
              id: Number(id)
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    borrar ({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        api.post('/comerciales/borrar', {
          jsondata: JSON.stringify({
            parametros: {
              id: Number(id)
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/comerciales/store.js